import { render, staticRenderFns } from "./EventPayments.vue?vue&type=template&id=512f2ac6&"
import script from "./EventPayments.vue?vue&type=script&lang=js&"
export * from "./EventPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports